var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        {
          staticClass: "pa-0 ma-0",
          staticStyle: { "max-width": "225px", overflow: "hidden" }
        },
        [
          _c(
            "v-row",
            { attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { staticClass: "text-left pa-4", attrs: { cols: "12" } },
                [
                  _c("settings-link", {
                    attrs: {
                      label: _vm.$t("nav.update-password"),
                      "select-value": "password",
                      icon: "lock"
                    },
                    on: {
                      selected: function($event) {
                        return _vm.updatePassword()
                      }
                    }
                  }),
                  _c("settings-link", {
                    attrs: {
                      label: _vm.$t("nav.logout"),
                      "select-value": "logout",
                      icon: "logout"
                    },
                    on: {
                      selected: function($event) {
                        return _vm.confirmLogout()
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }